import { useState } from 'react';
import { useStore } from '../context/ProductStore';
import { Plus, Trash2, Tag, ToggleLeft, ToggleRight, X } from 'lucide-react';
import './Coupons.css';

export default function Coupons() {
  const { coupons, addCoupon, deleteCoupon, toggleCoupon } = useStore();
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ code: '', discount: '', type: 'percent', minOrder: '', active: true });
  const [errors, setErrors] = useState({});

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleAdd = (e) => {
    e.preventDefault();
    const e2 = {};
    if (!form.code.trim())     e2.code     = 'Code is required';
    if (!form.discount)        e2.discount  = 'Discount value required';
    if (Object.keys(e2).length) { setErrors(e2); return; }
    addCoupon({ ...form, code: form.code.toUpperCase(), discount: Number(form.discount), minOrder: Number(form.minOrder) || 0 });
    setForm({ code: '', discount: '', type: 'percent', minOrder: '', active: true });
    setShowForm(false);
    setErrors({});
  };

  return (
    <div className="coupons-page">
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Coupon Codes</h1>
          <p className="admin-page-sub">{coupons.length} coupons · {coupons.filter(c=>c.active).length} active</p>
        </div>
        <button className="admin-btn admin-btn-primary" onClick={() => setShowForm(true)}>
          <Plus size={16} /> Add Coupon
        </button>
      </div>

      {/* Add form modal */}
      {showForm && (
        <div className="pl-modal-overlay">
          <div className="coupon-modal">
            <div className="coupon-modal-header">
              <h3>New Coupon Code</h3>
              <button className="admin-btn admin-btn-secondary admin-btn-icon" onClick={() => setShowForm(false)}><X size={16}/></button>
            </div>
            <form onSubmit={handleAdd} className="coupon-form">
              <div className="pf-field">
                <label className="pf-label">Coupon Code *</label>
                <input className={`pf-input ${errors.code ? 'error' : ''}`} value={form.code} onChange={e => set('code', e.target.value.toUpperCase())} placeholder="e.g. SAVE10" maxLength={20} />
                {errors.code && <p className="pf-error">{errors.code}</p>}
              </div>
              <div className="pf-row">
                <div className="pf-field">
                  <label className="pf-label">Discount Type</label>
                  <div className="pf-select-wrap">
                    <select className="pf-input pf-select" value={form.type} onChange={e => set('type', e.target.value)}>
                      <option value="percent">Percentage (%)</option>
                      <option value="flat">Flat Amount (₹)</option>
                    </select>
                  </div>
                </div>
                <div className="pf-field">
                  <label className="pf-label">Discount Value *</label>
                  <input className={`pf-input ${errors.discount ? 'error' : ''}`} type="number" min="1" value={form.discount} onChange={e => set('discount', e.target.value)} placeholder={form.type === 'percent' ? '10' : '50'} />
                  {errors.discount && <p className="pf-error">{errors.discount}</p>}
                </div>
              </div>
              <div className="pf-field">
                <label className="pf-label">Minimum Order Amount (₹)</label>
                <input className="pf-input" type="number" min="0" value={form.minOrder} onChange={e => set('minOrder', e.target.value)} placeholder="0 = no minimum" />
              </div>
              <div className="pf-field">
                <label className="pf-label">Status</label>
                <label className="coupon-toggle">
                  <input type="checkbox" checked={form.active} onChange={e => set('active', e.target.checked)} />
                  <span className="coupon-toggle-slider" />
                  <span className="coupon-toggle-label">{form.active ? 'Active' : 'Inactive'}</span>
                </label>
              </div>
              <div className="coupon-form-actions">
                <button type="submit" className="admin-btn admin-btn-primary">Create Coupon</button>
                <button type="button" className="admin-btn admin-btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Coupons grid */}
      <div className="coupons-grid">
        {coupons.map(c => (
          <div key={c.id} className={`coupon-card ${c.active ? 'active' : 'inactive'}`}>
            <div className="coupon-left">
              <div className="coupon-icon"><Tag size={20} /></div>
              <div>
                <p className="coupon-code">{c.code}</p>
                <p className="coupon-desc">
                  {c.type === 'percent' ? `${c.discount}% off` : `₹${c.discount} off`}
                  {c.minOrder > 0 ? ` · Min ₹${c.minOrder}` : ''}
                </p>
              </div>
            </div>
            <div className="coupon-right">
              <span className={`status-badge ${c.active ? 'status-published' : 'status-draft'}`}>
                {c.active ? 'Active' : 'Inactive'}
              </span>
              <button className="admin-btn admin-btn-secondary admin-btn-icon" onClick={() => toggleCoupon(c.id)} title="Toggle">
                {c.active ? <ToggleRight size={16} style={{ color: '#16803c' }} /> : <ToggleLeft size={16} />}
              </button>
              <button className="admin-btn admin-btn-danger admin-btn-icon" onClick={() => deleteCoupon(c.id)} title="Delete">
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}

        {coupons.length === 0 && (
          <div className="pl-empty" style={{ gridColumn: '1/-1' }}>
            <Tag size={48} />
            <h3>No coupons yet</h3>
            <p>Create your first coupon code to offer discounts to customers.</p>
            <button className="admin-btn admin-btn-primary" onClick={() => setShowForm(true)}>Add Coupon</button>
          </div>
        )}
      </div>
    </div>
  );
}
